import classNames from 'classnames';
import { LayoutModal, type LayoutModalProps } from '../layouts/LayoutModal';
import styles from './styles.module.css';
/**
 * Donation form styled modal component
 */
function Modal({
  fullWidth,
  innerClassName,
  className,
  ...props
}: Omit<LayoutModalProps, 'classNames'> & {
  fullWidth?: boolean;
  innerClassName?: string;
  className?: string;
}) {
  return <LayoutModal {...props} classNames={{
    modal: classNames(styles.donateFormModal, {
      [styles.donateFormModalWide!]: fullWidth
    }, className),
    modalInner: classNames({
      [styles.donateFormModalInnerWide!]: fullWidth
    }),
    titleContainer: styles.donateFormTitle,
    contentContainer: classNames(styles.donateFormModalContent, innerClassName)
  }} />;
}
export default Modal;